import { Controller } from 'react-hook-form'
import useCharForm, { ChatSchema } from './chat.form.hook'
import { Box, CircularProgress, ListItemText, MenuItem, Select, Stack, TextField } from '@vapor/material'
import { borderColorChat, noteColorChat, paddingChat } from '../common'
import { FormItem } from 'hic-components'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard, faComment, faInfo, faPaperPlane } from '@fortawesome/pro-regular-svg-icons'
import { HicIconButton } from '../../hic-vapor/button/icon-button'
import { SendThreadMessageMutation } from 'src/api/api.generated'
import { FetchResult } from '@apollo/client'

export default function ChatForm({ onSubmit, sendMessageLoading }: { onSubmit: (formValue: ChatSchema) => Promise<FetchResult<SendThreadMessageMutation>>; sendMessageLoading: boolean }) {
  const { t } = useTranslation()
  const { onFormSubmit, control, formValue, setValue } = useCharForm({ onSubmit })

  return (
    <form onSubmit={onFormSubmit}>
      <Stack gap={2} padding={paddingChat} borderTop={1} borderColor={borderColorChat} alignItems="start">
        <Controller<ChatSchema, 'isNote'>
          name={`isNote`}
          control={control}
          render={({ field: { onChange, value } }) => (
            <FormItem fieldLabel={''}>
              <Select
                size="small"
                value={value ? 'note' : 'message'}
                onChange={(event) => {
                  onChange(event.target.value === 'note')
                  setValue('message', '') // reset
                }}
                renderValue={(value) => {
                  return value === 'note' ? (
                    <>
                      <FontAwesomeIcon icon={faClipboard} style={{ marginRight: '0.5rem' }} />
                      {t('pms.messages.form.note')}
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faComment} style={{ marginRight: '0.5rem' }} />
                      {t('pms.messages.form.message')}
                    </>
                  )
                }}
              >
                <MenuItem value="message">
                  <FontAwesomeIcon icon={faComment} />
                  <ListItemText sx={{ marginLeft: 1 }} primary={t('pms.messages.form.message')} />
                </MenuItem>
                <MenuItem value="note">
                  <FontAwesomeIcon icon={faClipboard} />
                  <ListItemText sx={{ marginLeft: 1 }} primary={t('pms.messages.form.note')} />
                </MenuItem>
              </Select>
            </FormItem>
          )}
        />
        <Box width={'100%'} display="flex" gap={2} alignItems={'end'}>
          <Controller<ChatSchema, 'message'>
            name={`message`}
            control={control}
            render={({ field: { onChange, value } }) => (
              <FormItem
                fullWidth
                fieldLabel={
                  formValue.isNote ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <FontAwesomeIcon icon={faInfo} />
                      {t('pms.messages.form.note.title')}
                    </Box>
                  ) : (
                    ''
                  )
                }
              >
                <TextField
                  value={value ?? ''}
                  onChange={onChange}
                  multiline={true}
                  minRows={1}
                  maxRows={4}
                  size="small"
                  placeholder={formValue.isNote ? t('pms.messages.form.note.placeholder') : t('pms.messages.form.message.placeholder')}
                  sx={{ '& .MuiInputBase-input': { backgroundColor: formValue.isNote ? noteColorChat : undefined } }}
                />
              </FormItem>
            )}
          />
          {sendMessageLoading ? (
            <CircularProgress color="secondary" size={32} />
          ) : (
            <HicIconButton onClick={onFormSubmit} size="small" sx={{ minWidth: '0!important', minHeight: '0!important' /* , padding: '0' */ }}>
              <FontAwesomeIcon icon={faPaperPlane} size="xl" />
            </HicIconButton>
          )}
        </Box>
      </Stack>
    </form>
  )
}
